import React, {
    FC,
    useState,
} from "react";
import {Box} from "@mui/material";
import {AuthorizedUser} from "./AuthorizedUser";
import {LoginDialog} from "./LoginDialog";
import {UnAuthorizedUser} from "./UnAuthorizedUser";
import {fbLogin} from "../../api/apiService";

export const Authorization: FC = () => {
    const [open, setOpen] = useState(false);
    const [fbUser, setFbUser] = useState<any>(null);
    const authorizedUser = localStorage.getItem("fbUser");

    if (!fbUser && authorizedUser)
    {
        setFbUser(JSON.parse(authorizedUser));
    }
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleFacebookLoginSuccess = (user: any) => {
        console.log("Facebook User Data:", user);
        window.FB.getLoginStatus(async (response: any) => {
            if (response.status === "connected") {
                const accessToken = response.authResponse.accessToken;
                console.log("Facebook Access Token:", accessToken);
                let localUser: any = await fbLogin(accessToken);
                user.session = localUser.session;
                localStorage.setItem("fbUser", JSON.stringify(user));
            }
        });

        setFbUser(user);
        setOpen(false);
    };
    const handleFacebookLoginFailure = () => {
        console.error("Facebook login failed");
    };
    const handleLogout = () => {
        console.log("User logged out");
        setFbUser(null);
        localStorage.removeItem("fbUser");
    };
    return (
        <Box sx={{display: "flex", alignItems: "center", marginLeft: "10px"}}>
            {
                fbUser ? (
                    <AuthorizedUser user={fbUser} onLogout={handleLogout}/>
                ) : (
                    <UnAuthorizedUser handleClickOpen={handleClickOpen}/>
                )}
            <LoginDialog
                open={open}
                onClose={handleClose}
                onLoginSuccess={handleFacebookLoginSuccess}
                onLoginFailure={handleFacebookLoginFailure}
            />
        </Box>
    );
};
